// Languages of this app (AgDR-0051, amendment of 2026-10-28).

/** The shared language list of the paved road, French first (primary market). */
export const SHARED_LANGUAGES = ['fr', 'en', 'es', 'de', 'pt', 'it'] as const;

export type SharedLanguage = (typeof SHARED_LANGUAGES)[number];

/**
 * Languages this app ships, one `public/locales/<lng>/` folder each. A language is announced
 * to i18next (`supportedLngs`) only once its files exist: an unshipped one then resolves to the
 * fallback below instead of setting `<html lang>` to a language the page is not written in.
 * Add a language here in the same change as its reviewed translation (languages.test.ts).
 */
export const SHIPPED_LANGUAGES: readonly SharedLanguage[] = ['fr', 'en'];

/** Fallback order, kept to the shipped languages: English, the most read language, then French. */
const FALLBACK_ORDER: readonly SharedLanguage[] = ['en', 'fr'];

export const FALLBACK_LANGUAGES = FALLBACK_ORDER.filter((lng) => SHIPPED_LANGUAGES.includes(lng));
